<!-- 编辑弹窗部分 -->
<template>
  <div>
    <a-form ref="formRef" :model="data.form" layout="vertical" :rules="data.rules">
      <a-row type="flex" justify="space-between">
        <template v-for="(item, index) in props.formList" :key="index">
          <a-col
            :span="cloSpan(item, index)"
            :style="{
              flex: props.fromVal === 'blformRef' && [0, 1, 2].includes(index) ? '0' : '',
              borderBottom: item.bottomBorder ? '10px solid #F5F5F5' : '',
              marginTop: item.marginTop ? '20px' : ''
            }"
            :class="[
              props.fromVal === 'blformRef' && [0, 1, 2].includes(index)
                ? 'inputClass'
                : item.type === 5 || item.slots
                ? ''
                : item.keyTwo === 'activityId'
                ? 'activity'
                : 'time',
              item.type === 99 ? '' : 'normalizeCol'
            ]"
            v-if="'isExpend' in item ? item.isExpend && item.isShow : item.isShow"
          >
            <a-form-item
              :name="item.keyOne ? [item.keyOne, item.keyTwo] : item.key"
              :class="[item.type === 11 ? 'file-list' : '']"
              v-if="!item.slots"
            >
              <template v-slot:label>
                <span class="formTitle">{{ item.title }}</span>
                <span v-if="item.guide" class="guide" @click="handleUploadGuide(item.auxiliaryKey)">
                  <QuestionCircleOutlined :style="{ fontSize: '12px', marginRight: '3px' }" />
                  {{ item.guide }}
                </span>
              </template>

              <template v-if="[1].includes(item.type)">
                <a-input-number
                  v-if="item.keyOne && data.form[item.keyOne]"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder"
                  v-model:value="data.form[item.keyOne][item.keyTwo]"
                  :max="item.max"
                  :min="item.min"
                  :precision="item.type === 1 ? 0 : 2"
                  @change="numberChange($event, item)"
                ></a-input-number>
                <a-input-number
                  v-else
                  :disabled="item.disabled"
                  :placeholder="item.placeholder"
                  v-model:value="data.form[item.key]"
                  :max="item.max"
                  :min="item.min"
                  :precision="item.type === 1 ? 0 : 2"
                  @change="numberChange($event, item)"
                ></a-input-number>
              </template>
              <a-input
                v-if="[4].includes(item.type)"
                :disabled="item.disabled"
                :placeholder="item.placeholder"
                v-model:value="data.form[item.key]"
                :maxlength="item.maxlength"
              ></a-input>
              <template v-if="[8, 12].includes(item.type)">
                <a-select
                  v-if="item.keyOne && data.form[item.keyOne]"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder"
                  v-model:value="data.form[item.keyOne][item.keyTwo]"
                  :allowClear="item.allowClear"
                  @change="selectChange($event, item.key, item.options)"
                >
                  <a-select-option
                    v-for="(oItem, oIndex) in item.options"
                    :value="oItem.value"
                    :key="oIndex"
                  >
                    {{ oItem.label }}
                  </a-select-option>
                </a-select>
                <a-select
                  v-else
                  :disabled="item.disabled"
                  :placeholder="item.placeholder"
                  v-model:value="data.form[item.key]"
                  :allowClear="item.allowClear"
                  @change="selectChange($event, item.key, item.options)"
                >
                  <a-select-option
                    v-for="(oItem, oIndex) in item.options"
                    :value="oItem.value"
                    :key="oIndex"
                  >
                    {{ oItem.label }}
                  </a-select-option>
                </a-select>
              </template>

              <template v-if="[3].includes(item.type)">
                <a-date-picker
                  v-if="item.keyOne && data.form[item.keyOne]"
                  :disabled="item.disabled"
                  :placeholder="item.placeholder"
                  v-model:value="data.form[item.keyOne][item.keyTwo]"
                  :allowClear="item.allowClear"
                  valueFormat="YYYY-MM-DD"
                  :disabled-date="toEvent(item)"
                  @change="startDateChange($event, item)"
                />
                <a-date-picker
                  v-else
                  :disabled="item.disabled"
                  :placeholder="item.placeholder"
                  v-model:value="data.form[item.key]"
                  :allowClear="item.allowClear"
                  valueFormat="YYYY-MM-DD"
                  :disabled-date="toEvent(item)"
                  @change="startDateChange($event, item)"
                />
              </template>

              <a-cascader
                v-if="[10].includes(item.type)"
                :disabled="item.disabled"
                :placeholder="item.placeholder"
                v-model:value="data.form[item.key]"
                :allowClear="item.allowClear"
                :options="item.options"
                :fieldNames="item.fieldNames"
                @change="departmentChange($event, item.key, item.options)"
              />
              <a-textarea
                v-if="[5].includes(item.type)"
                :disabled="item.disabled"
                :placeholder="item.placeholder"
                v-model:value="data.form[item.key]"
                :allowClear="item.allowClear"
                showCount
                :maxlength="item.maxlength"
              />
              <a-switch
                v-if="[13].includes(item.type)"
                :checked-children="item.checkedChildren"
                :un-checked-children="item.unCheckedChildren"
                v-model:checked="data.form[item.key]"
                @change="switchClick($event, item)"
                :disabled="item.disabled"
              />
              <template v-if="[11].includes(item.type)">
                <div class="uploadFlex">
                  <div class="uploadleft">
                    <UploadEdit
                      :ref="el => setUploadEditRef(el, item.auxiliaryKey)"
                      @onSuccess="onSuccessUpload"
                      @updetaList="onSuccessUpload"
                      :index="item.auxiliaryKey"
                      :nameMaxlength="30"
                      :canEditName="false"
                      :fileList="data.form[item.auxiliaryKey]"
                      :maxLength="item.imgMaxLength"
                      :needGuide="item.auxiliaryKey === 'ocrImgUrlList' ? true : false"
                      style="width: 80px; height: 80px"
                    />
                    <div
                      v-if="
                        data.form[item.auxiliaryKey] && data.form[item.auxiliaryKey].length === 0
                      "
                      style="margin-left: 12px"
                    >
                      <div class="formImgShowTxt">
                        {{ item.tips }}
                      </div>
                      <div class="uploadWarn">
                        （支持jpg/png格式，限10M以内。最多上传{{ item.imgMaxLength }}张）
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </a-form-item>
            <template v-else>
              <slot name="items" :formItem="item"></slot>
            </template>
          </a-col>
        </template>
      </a-row>
    </a-form>
  </div>
</template>
<script setup>
import { reactive, defineProps, watch, onMounted, ref, toRaw, defineEmits, defineExpose } from 'vue'
// import { PlusOutlined } from '@ant-design/icons-vue'
import { formItemType, medicalHistoryList } from '../hooks/useComponent'
// import { message } from 'ant-design-vue'
import { deepClone } from '../../../../utils/index'
import UploadEdit from '@/components/UploadEdit'
import store from '@/store'
import moment from 'moment'
import { QuestionCircleOutlined } from '@ant-design/icons-vue'

const props = defineProps({
  fromVal: {
    type: String,
    default: 'blformRef'
  },
  formList: {
    type: Array,
    default: () => []
  },
  current: {
    type: Number,
    default: 0
  },
  toRequired: {
    type: Number,
    default: 0
  },
  formProp: {
    type: Object,
    default: () => {}
  },
  rulesProp: {
    type: Object,
    default: () => {}
  },
  id: {
    type: String,
    default: ''
  },
  isDrug: {
    type: Boolean,
    default: true
  },
  doctorInProject: {
    type: Boolean,
    default: true
  },
  isOcr: {
    type: Boolean,
    default: false
  }
})

const formRef = ref()
const data = reactive({
  form: props.formProp,
  current: 0,
  action: process.env.VUE_APP_BASE_API + '/file/upload/batch',
  header: {
    token: store.getters.token
  },
  dataForm: {
    type: '1'
  },
  previewImage: require('@/assets/img/img-err.png'),
  previewVisible: false,
  departmentList: [],
  rules: {},
  medicalHistoryList: medicalHistoryList,
  rulesPropData: {}
})
//如果开始时间存在，初始化结束时间

if (data.form.beginTime) {
  data.form.prescriptionInfo.beginTime = moment(data.form.prescriptionInfo.beginTime).format(
    'YYYY-MM-DD'
  )
  endDateChange(data.form.prescriptionInfo.beginTime, data.form.prescriptionInfo.medicineCycle)
}
const emit = defineEmits(['validateChange', 'selectChange', 'startDateChange', 'switchClick'])
const toEvent = item => {
  if (item.key === 'prescriptionInfo.beginTime' && props.doctorInProject) {
    return betweenSevenDays
  }
  if (item.disabledDate === '>days') {
    return disabledDate
  }
}
// 只能选择今天以前的日期，>今天的都disabled
const disabledDate = current => {
  return current && current > moment().endOf('day')
}
// 只能选择前七天和后七天的时间
const betweenSevenDays = current => {
  const beforeSevenDays = moment().subtract(8, 'days')
  const afterSevenDays = moment().add(7, 'days')
  return current && (current <= beforeSevenDays || current > afterSevenDays)
}
const switchClick = (e, item) => {
  emit('switchClick', e, item)
}

const startDateChange = (e, item) => {
  if (e) {
    if (item.key === 'prescriptionInfo.beginTime') {
      endDateChange(data.form.prescriptionInfo.beginTime, data.form.prescriptionInfo.medicineCycle)
    }
  } else {
    data.form.endTime = undefined
    emit('startDateChange', data.form.endTime)
  }
}

const uploadEditRefs = ref({})

const setUploadEditRef = (el, key) => {
  if (el) {
    uploadEditRefs.value[key] = el
  }
}

const handleUploadGuide = key => {
  // 点击如何上传时，调用UploadEdit子组件的方法清空并显示UploadPrescription弹窗（支持覆盖上传）
  if (key === 'ocrImgUrlList' && uploadEditRefs.value[key]) {
    uploadEditRefs.value[key].showUploadGuide()
  }
}

const selectChange = (e, key, options) => {
  if (key === 'prescriptionInfo.medicineCycle') {
    if (data.form.prescriptionInfo.beginTime) {
      endDateChange(data.form.prescriptionInfo.beginTime, data.form.prescriptionInfo.medicineCycle)
    }
  }
  emit('selectChange', e, key, options)
}

// 修改结束时间
function endDateChange(beginTime, medicineCycle) {
  const endTime = moment(beginTime).add(medicineCycle, 'days')
  data.form.prescriptionInfo.endTime = endTime.format('YYYY-MM-DD')
  emit('startDateChange', data.form.prescriptionInfo.endTime)
  //data.form.endTime = moment(beginTime).add(medicineCycle, 'days')
}

const numberChange = (e, item) => {
  const { beginTime = null } = data.form?.prescriptionInfo || {}
  if (item.key === 'prescriptionInfo.medicineCycle' && beginTime) {
    endDateChange(data.form.prescriptionInfo.beginTime, e)
  }
}
// const cloSpan = (item, index) => {
//   return [4, 5, 6, 9, 10, 11, 12, 13].includes(index) ? 24 : 12
//   // if (props.fromVal === 'blformRef') {
//   //   return [3].includes(index) ? 24 : [0, 1, 2].includes(index) ? 8 : 12
//   // } else if (props.fromVal === 'ypformItem') {
//   //   return [0, 1, 5, 6].includes(index) ? 24 : 12
//   // }
// }
const cloSpan = (item, index) => {
  return [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16].includes(index) ? 24 : 12
}

const addRules = () => {
  return new Promise(resolve => {
    const ruleObj = reactive([])
    const rules = reactive([])
    const rulesItem = reactive({})
    data.rulesPropData = deepClone(props.rulesProp)
    if (!props.isDrug) {
      data.rulesPropData.drugInput.required = false
      data.rulesPropData.drugInput.validator = () => {
        return Promise.resolve()
      }
      data.rulesPropData.drugCheck = data.rulesPropData.drugInput
    } else {
      data.rulesPropData = deepClone(props.rulesProp)
    }
    props.formList.map(item => {
      // OCR场景下，如果字段有requiredOcr属性且为true，则设为必填
      const isOcrRequired = props.isOcr && item.requiredOcr
      item.required = item.requiredDrug ? props.isDrug : isOcrRequired || item.required
      const rule = {
        required: item.required && item.isShow,
        message: item.placeholder + ([4].includes(item.type) ? '(禁止输入表情)' : ''),
        type: item.type === 99 ? null : formItemType[item.type - 1].type,
        trigger: ['change'],
        default: item.type === 99 ? null : formItemType[item.type - 1].default
      }
      // 就诊人自定义校验：只允许中文和字母
      if (item.validator === 'patientNameValidator') {
        rule.pattern = /^[\u4e00-\u9fa5a-zA-Z]+$/
        rule.message = '请输入正确的就诊人姓名'
      }
      if (item.keyOne) {
        rulesItem[item.keyTwo] = rule
      } else {
        ruleObj[item.key] = rule
      }
    })
    rules['prescriptionInfo'] = rulesItem
    const datar = { ...rules, ...ruleObj, ...data.rulesPropData }
    data.rules = datar
    console.log('校验', data.rules)
    resolve()
  })
}
const departmentChange = (e, key, options) => {
  //选择科室
  if (key === 'offlineDepartment') {
    options.map(fItem => {
      if (fItem.departName === e[0]) {
        fItem.secondDepart.map(cItem => {
          if (e[1] == cItem.departName) {
            // data.form.offlineDepartment = [dItem.departName, sItem.departName]
            data.form.departmentInfo = {
              departmentName: cItem.departName,
              departmentId: cItem.departId,
              parentDepartmentId: fItem.departId,
              parentDepartmentName: fItem.departName
            }
          }
        })
      }
    })
  }
}
// function getBase64(file) {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader()
//     reader.readAsDataURL(file)
//     reader.onload = () => resolve(reader.result)
//     reader.onerror = error => reject(error)
//   })
// }
// const handlePreview = async file => {
//   if (!file.url && !file.preview) {
//     file.preview = await getBase64(file.originFileObj)
//   }
//   data.previewImage = file.url || file.preview
//   data.previewVisible = true
// }
// const handleCancel = () => {
//   data.previewVisible = false
// }
// const handleChange = ({ fileList: newFileList }, item) => {
//   const { key, auxiliaryKey, imgMaxLength } = item
//   if (newFileList.length > imgMaxLength) return
//   data.form[key] = newFileList
//     return imgUrl
//   })
// }
const onSuccessUpload = (fileList, index, rawFile) => {
  data.form[index] = fileList.map(it => {
    return {
      filePath: it.path,
      fileName: it.name
    }
  })

  // 当上传的是处方图片(ocrImgUrlList)时，通知父组件进行OCR识别
  if (index === 'ocrImgUrlList' && fileList.length > 0) {
    // 传递原始文件对象给父组件，由父组件以multipart/form-data格式调用OCR识别接口
    emit('recPrescriptionOcr', { rawFile, type: 'ocrUpload' })
  }
  // 当删除处方图片(ocrImgUrlList)且列表为空时，通知父组件清空OCR表单数据
  if (index === 'ocrImgUrlList' && fileList.length === 0) {
    emit('recPrescriptionOcr', { type: 'ocrClear' })
  }
}

// const beforeUpload = file => {
//   return new Promise((resolve, reject) => {
//     const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
//     if (!isJpgOrPng) {
//       message.error('请上传 JPG/PNG 格式图片!')
//       return reject(false)
//     }
//     const isLt10M = file.size / 1024 / 1024 < 10
//     if (!isLt10M) {
//       message.error('请上传 ≤ 10MB 以内的图片')
//       return reject(false)
//     }
//     return resolve(true)
//   })
// }

const validateChange = () => {
  return new Promise(resolve => {
    // 病史信息和药品信息校验
    //校验病历信息的必填项
    addRules().then(() => {
      formRef.value
        .validate()
        .then(() => {
          console.log('values校验成功', toRaw(data.form))
          //校验成功
          emit('validateChange', data.form)
          resolve(true)
        })
        .catch(error => {
          emit('validateChange', 'error')
          console.log('error', error)
          resolve(false)
        })
    })
  })
}

const clearValidForTreat = () => {
  // console.log('formRef.value', formRef.value)
  formRef.value.clearValidate(['reserveDate', 'reserveDateDetail', 'revisitType'])
}

defineExpose({
  clearValidForTreat,
  validateChange,
  endDateChange,
  handleUploadGuide
})

onMounted(() => {
  data.current = props.current
})

watch(
  () => [props.toRequired, props.formProp, props.current],
  newValues => {
    if (newValues[0] !== newValues[2]) {
      validateChange()
    } else if (newValues[0] === newValues[2]) {
      if (formRef.value) {
        formRef.value.clearValidate()
      }
    }
    data.form = props.formProp
  },
  {
    immediate: true
  }
)

watch(
  () => props.isDrug,
  n => {
    addRules(n, 'check')
  },
  {
    immediate: true
  }
)

watch(
  () => props.isOcr,
  () => {
    addRules()
  },
  {
    immediate: false
  }
)
</script>
<style scoped lang="scss">
@import './medicalRecordsPoup.scss';
</style>
